
import axiosinstances from "../Helper/useAxios";

 export async function getprofileserviicesresponse(data) {
    const [axiosInstance] = axiosinstances() 
    const d=sessionStorage.getItem('token') && JSON.parse(sessionStorage.getItem('token')).token ? JSON.parse(sessionStorage.getItem('token')).token : "";
    //console.log('d', d)
    const e=JSON.parse(sessionStorage.getItem('token'))
    const profileId=JSON.parse(sessionStorage.getItem('profileId'))
    return  axiosInstance
    .get(`/api/v1/retailer/get/${profileId}`,{ headers: {"Authorization" : `Bearer ${e}`,"client-id":profileId,"role":"ROLE_RETAILER_FINXPAY"}})
    .then(response => {
        if (response) {
            const { data } = response
            return data
        }
        return false
    })
   .catch((err) => {
     //console.log(err);
   });
    // return axios.get(`http://qa.finxpay.co.in/api/v1/retailer/get/${profileId}`,{ headers: {"Authorization" : `Bearer ${e}`,"client-id":profileId,"role":"ROLE_RETAILER_FINXPAY"}})
    // .then(response => {

        
    //         if (response) {
    //             const { data } = response
                 
    //             return data
    //         }
    //         return false
    //     })
}
